import app from 'flarum/forum/app';
import type Mithril from 'mithril';
import { extend, override } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import TagsPage from 'flarum/forum/tags/components/TagsPage';
import PagePagePC from './components/PagePagePC';
import ItemList from 'flarum/common/utils/ItemList';
import classList from 'flarum/common/utils/classList';
import Link from 'flarum/common/components/Link';
import SearchSource from 'flarum/forum/components/Search';
import ComposerBody from 'flarum/forum/components/ComposerBody';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import Navigation from 'flarum/common/components/Navigation';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import SearchButton from '../common/components/SearchButton';
import PostButton from '../common/components/PostButton';
import ResponseItemsBtn from 'flarum/common/components/ResponseItemsBtn';
import UploadFileButton from '../common/components/UploadFileButton';
import HomePage from './components/HomePage';
import TagView from './components/TagView';
import TextEditor from 'flarum/common/components/TextEditor';
import listItems from 'flarum/common/helpers/listItems';
import ComposerState from 'flarum/forum/states/ComposerState';
import Composer from 'flarum/forum/components/Composer';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import NotificationsPage from 'flarum/forum/components/NotificationsPage';
import DiscussionListPane from 'flarum/forum/components/DiscussionListPane';
import PostUser from 'flarum/forum/components/PostUser';
import PostStream from 'flarum/forum/components/PostStream';
import PostLoading from 'flarum/forum/components/LoadingPost';
import CommentPost from 'flarum/forum/components/CommentPost';
import SubscriptionMenu from 'flarum/subscriptions/components/SubscriptionMenu';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import nickname from 'flarum/common/helpers/nickname';
import humanTime from 'flarum/common/helpers/humanTime';
import UserCard from 'flarum/forum/components/UserCard';
import UserPage from 'flarum/forum/components/UserPage';
import LikePage from 'flarum/forum/dianLiang/LikePage';
import MentionPage from 'flarum/forum/dianLiang/MentionPage';
import SettingPage from 'flarum/forum/dianLiang/SettingPage';
import LikesPage from 'flarum/forum/dianLiang/LikesPage';
import PayPage from 'flarum/forum/dianLiang/PayPage';
import MallPage from 'flarum/forum/dianLiang/MallPage';
import MallOrderPage from 'flarum/forum/dianLiang/MallOrderPage';
import CommentsPage from 'flarum/forum/dianLiang/CommentsPage';
import ProfilePagePhone from 'flarum/forum/dianLiang/ProfilePagePhone';
import SearchView from '../forum/components/SearchView';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import icon from 'flarum/common/helpers/icon';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import ReplyPlaceholder from 'flarum/forum/components/ReplyPlaceholder';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import PagePage from '../common/models/PagePage';
import Separator from 'flarum/common/components/Separator';
import LogInModal from 'flarum/forum/components/LogInModal';
import FlagsPage from 'flarum/flags/components/FlagsPage';
import ForumApplication from 'flarum/forum/ForumApplication';
import NavigationBar from '../forum/components/NavigationBar';
import FloatPostButton from '../common/components/FloatPostButton';
import EditPostComposer from 'flarum/forum/components/EditPostComposer';
import Dropdown from 'flarum/common/components/Dropdown';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';
import CommentUtil from 'flarum/common/dianliang/commentUtil';
import RouteToBindRoleModal from 'flarum/common/dianliang/RouteToBindRoleModal';
import RoleBindingModal from 'flarum/forum/dianLiang/RoleBindingModal';
import Md5Util from 'flarum/common/dianliang/Md5Util';
// import { getSDK, CbEvents, LogLevel } from '@openim/wasm-client-sdk';

// import type { WSEvent } from '@openim/wasm-client-sdk/lib/types/entity';
// import { getWithRenderProcess } from '@openim/electron-client-sdk/lib/render';
// import OpenIMSDKMain from '@openim/electron-client-sdk';

export default function () {

  IndexPage.prototype.centerTabs = function () {
    return PagePage.prototype.centerTabs();
  };
  PagePage.prototype.centerNavItems = function () {
    const list = app.store.all('centerIconCategories').sort((a, b) => a.sortcount() - b.sortcount());
    const centerOnClick = (event) => {
    //   if (!app.session.user) {
    //     event.preventDefault();
    //     app.modal.show(LogInModal);
    //     return;
    //   }
    };
    if (app.store.models.type != 'phone') {
      return (
        <div className="dl-blocks" id="dl-blocks">
          {list &&
            list.map((category) => {
              let url = app.forum.attribute('baseUrl');
              let iconName = category.iconName();
              let localeIconNameFirst = '';
              let localeIconNameSecond = '';
              if (iconName) {
                // 将字符串映射转换为 JavaScript 对象
                const obj = JSON.parse(iconName);
                // 创建 Map 对象并初始化
                const map = new Map(Object.entries(obj));
                const objPc = map.get('pc');
                // 获取特定键的值
                localeIconNameFirst = objPc['first'][app.data.locale];
                localeIconNameSecond = objPc['second'][app.data.locale];
              }
              let iconImg = category.iconImg();
              let localeIconImg = '';
              if (iconImg) {
                // 将字符串映射转换为 JavaScript 对象
                const obj2 = JSON.parse(iconImg);
                // 创建 Map 对象并初始化
                const map2 = new Map(Object.entries(obj2));
                localeIconImg = map2.get('pc');
                if (app.store.models.type == 'phone') {
                  localeIconImg = map2.get('phone');
                }
              }
              return (
                <a
                  href={
                    category.iconLink()
                      ? category.iconLink() && category.iconLink().includes('http')
                        ? category.iconLink()
                        : url + category.iconLink()
                      : '#'
                  }
                  onclick={centerOnClick}
                  icon=""
                >
                  <div className={`dl-block ${app.data.locale == 'zh-Hans' || app.data.locale == 'zh-Hant' ? 'dl-block-zh' : 'dl-block-en'}`}>
                    <img src={localeIconImg} />
                    <p>{localeIconNameFirst}</p>
                    <p>{localeIconNameSecond}</p>
                  </div>
                </a>
              );
            })}
        </div>
      );
    } else {
      return (
        <div className="dl-blocks" id="dl-blocks">
          {list &&
            list.map((category) => {
              let url = app.forum.attribute('baseUrl');
              let iconName = category.iconName();
              let localeIconName = '';
              if (iconName) {
                // 将字符串映射转换为 JavaScript 对象
                const obj = JSON.parse(iconName);
                // 创建 Map 对象并初始化
                const map = new Map(Object.entries(obj));
                const objPhone = map.get('phone');
                // 获取特定键的值
                localeIconName = objPhone[app.data.locale];
              }
              let iconImg = category.iconImg();
              let localeIconImg = '';
              if (iconImg) {
                // 将字符串映射转换为 JavaScript 对象
                const obj2 = JSON.parse(iconImg);
                // 创建 Map 对象并初始化
                const map2 = new Map(Object.entries(obj2));
                localeIconImg = map2.get('pc');
                if (app.store.models.type == 'phone') {
                  localeIconImg = map2.get('phone');
                }
              }
              return (
                <a
                  href={
                    category.iconLink()
                      ? category.iconLink() && category.iconLink().includes('http')
                        ? category.iconLink()
                        : url + category.iconLink()
                      : '#'
                  }
                  onclick={centerOnClick}
                  icon=""
                >
                  <div className="dl-block">
                    <img src={localeIconImg} />
                    <p>{localeIconName}</p>
                  </div>
                </a>
              );
            })}
        </div>
      );
    }
  };

  IndexPage.prototype.pushPost = function () {
    return !app.session.user?.suspendedUntil() && <FloatPostButton />;
  };

  extend(HeaderSecondary.prototype, 'items', function (items) {
    // if (app.store.models.type == 'phone') {
    if (app.session.user) {
      const user = app.session.user!;
      items.remove('session');
      items.add(
        'profile controls-item',
        <LinkButton icon="fas fa-user" href={app.route.user(user)}>
          {app.translator.trans('core.forum.header.profile_button')}
        </LinkButton>,
        85
      );

      items.add(
        'settings controls-item',
        <LinkButton icon="fas fa-cog" href={app.route('settings')}>
          {app.translator.trans('core.forum.header.settings_button')}
        </LinkButton>,
        50
      );

      if (app.forum.attribute('adminUrl')) {
        items.add(
          'administration controls-item',
          <LinkButton icon="fas fa-wrench" href={app.forum.attribute('adminUrl')} target="_blank">
            {app.translator.trans('core.forum.header.admin_button')}
          </LinkButton>,
          0
        );
      }

      items.add('separator', <Separator />, -90);

      items.add(
        'logOut',
        <Button icon="fas fa-sign-out-alt" onclick={app.session.logout.bind(app.session)}>
          {app.translator.trans('core.forum.header.log_out_button')}
        </Button>,
        -100
      );
      // items.add('session', <SessionDropdown />, 0);
    }
    let allPkgLogo = app.data.allPkgLogo.filter((pkgLogo) => {
      return pkgLogo.id != app.data.pkgLogo.id && pkgLogo.status == 1;
    });

    if (allPkgLogo.length > 0) {
      items.add(
        'multiple-games',
        <div className="multiple-games-box">
          <div className="title">{app.translator.trans('dl-send.forum.other_flarum')}</div>
          <div className="game-list">
            {allPkgLogo
              // .filter((pkgLogo) => {
              //   return pkgLogo.id != app.data.pkgLogo.id;
              // })
              .map((item) => {
                const obj = JSON.parse(item.pkgName);
                const map = new Map(Object.entries(obj));
                let localePkgName = map.get(app.data.locale);
                const obj2 = JSON.parse(item.pkgIcon);
                const map2 = new Map(Object.entries(obj2));
                let localePkgIcon = map2.get(app.data.locale);
                let pkgStr = item.pkgStr;
                let origin = window.location.origin;
                let url = origin + '/' + pkgStr;
                let base64Encoded = '';
                if (app.session.user) {
                  let md5Map = new Map();
                  md5Map.set('pkgId', String(item.id));
                  md5Map.set('userName', app.session.user.username());
                  md5Map.set('userId', String(app.session.user.uniqueID()));
                  md5Map.set('language', app.data.locale);
                  md5Map.set('email', app.session.user.email());
                  const obj = {};
                  for (const [key, value] of md5Map) {
                    obj[key] = value;
                  }
                  // 将对象转换为字符串
                  const mapString = JSON.stringify(obj); // 转换为 JSON 字符串
                  base64Encoded = btoa(unescape(encodeURIComponent(mapString)));
                }
                return (
                  <div
                    className="game-item"
                    onclick={() => {
                      sessionStorage.removeItem('tagItem');
                      window.location.assign(url);
                      // app.request({
                      //   method: 'GET',
                      //   url: app.forum.attribute('baseUrl') + '/routeToGame/' + base64Encoded,
                      // }).then((res) => {
                      //   window.location.href = res.url;
                      // })
                    }}
                  >
                    <div className="head">
                      <img src={localePkgIcon} alt="" />
                    </div>
                    <div className="name">{localePkgName}</div>
                    {/* <Button
                        className={'collection-btn ' + (false ? 'collection-btn-follow-bg' : 'collection-btn-null-bg')}
                        aria-label="collection"

                      ></Button> */}
                  </div>
                );
              })}
          </div>
        </div>,
        80
      );
    }

    // }
  });

  extend(TextEditor.prototype, 'controlItems', function (items) {
    // if (app.store.models.type == 'phone') {
    let user = app.session.user;
    //用户
    if (user.groups().length == 0) {
      items.remove('preview');
    }
    // }
  });

  extend(SessionDropdown.prototype, 'items', function (items) {
    // if (app.store.models.type == 'phone') {
    items.remove('logOut');
    if (app.session.user.canLogOut()) {
      items.add(
        'logOut',
        <Button icon="fas fa-sign-out-alt" onclick={app.session.logout.bind(app.session)}>
          {app.translator.trans('core.forum.header.log_out_button')}
        </Button>,
        -100
      );
    }
    return items;
    // }
  });

  override(IndexPage.prototype, 'hero', function () {
    return PagePagePC.prototype.headerView();
  });

  // override(IndexPage.prototype, 'headerSlideShow', function () {
  //   return PagePagePC.prototype.headerSlideShowView();
  // });

  override(TagsPage.prototype, 'pageContent', function (original) {
    // if (app.store.models.type == 'phone') {
    const items = new ItemList();
    items.add('main', <div className="container">{this.mainContent().toArray()}</div>, 10);
    return items;
    // } else {
    //   return original();
    // }
  });

  override(TagsPage.prototype, 'mainContent', function (original) {
    // if (app.store.models.type == 'phone') {
    const items = new ItemList();
    items.add('content', this.content(), 10);
    return items;
    // } else {
    //   return original();
    // }
  });

  override(TagsPage.prototype, 'view', function (original) {
    // if (app.store.models.type == 'phone') {
    return (
      <div className="TagsPage">
        {/* {this.title()} */}
        <div className="dl-header-tabs">{PagePage.prototype.headerTabs(this)}</div>
        {this.pageContent().toArray()}
      </div>
    );
    // } else {
    //   return original();
    // }
  });

  override(TagsPage.prototype, 'tagTileView', function (original, tag) {
    // if (app.store.models.type == 'phone') {
    let subImg = tag.subImg();
    // 将字符串映射转换为 JavaScript 对象
    let obj = JSON.parse(subImg);
    // 创建 Map 对象并初始化
    let map = new Map(Object.entries(obj));
    // 获取特定键的值
    let localeSubImg = map.get(app.data.locale);

    let name = tag.name();
    // 将字符串映射转换为 JavaScript 对象
    obj = JSON.parse(name);
    // 创建 Map 对象并初始化
    map = new Map(Object.entries(obj));
    // 获取特定键的值
    let localeName = map.get(app.data.locale);
    return (
      <li className={classList('TagTile')}>
        <Link className="tagItem" href={app.route.tag(tag)}>
          <img class="tagImg" src={localeSubImg ? localeSubImg : map.get('en')} />
          <span className="tag-text">{localeName ? localeName : map.get('en')}</span>
          {/* {app.data.locale === 'zh-Hans' && <img class="tagImg" src={tag.zhHansImgUrl() ? tag.zhHansImgUrl() : tag.enImgUrl()} />}
            {app.data.locale === 'zh-Hant' && <img class="tagImg" src={tag.zhHantImgUrl() ? tag.zhHantImgUrl() : tag.enImgUrl()} />}
            {app.data.locale === 'en' && <img class="tagImg" src={tag.enImgUrl()} />}
            {app.data.locale === 'fr' && <img class="tagImg" src={tag.frImgUrl() ? tag.frImgUrl() : tag.enImgUrl()} />}
            {app.data.locale === 'de' && <img class="tagImg" src={tag.deImgUrl() ? tag.deImgUrl() : tag.enImgUrl()} />}
            {app.data.locale === 'vi' && <img class="tagImg" src={tag.vnImgUrl() ? tag.vnImgUrl() : tag.enImgUrl()} />} */}
        </Link>
      </li>
    );
    // } else {
    //   return original(tag);
    // }
  });

  //判断当前页面抬头栏需不需要两行
  override(Navigation.prototype, 'view', function (original) {
    const { history, pane } = app;
    // if (app.store.models.type == 'phone') {
    let pkgLogo = app.data.pkgLogo;
    const appNavigation = document.getElementById('app-navigation');
    let isOne = false;
    let isTwo = false;
    let isSearch = true;
    let isWallet = false;
    let isCS = false;
    let feedbackStatus = app.session.user && app.forum.attribute('feedbackStatus');
    let walletStatus = app.session.user && app.forum.attribute('walletStatus');
    const isIOSOrMacOS = /iPad|iPhone|iPod|Macintosh|Mac OS X/i.test(navigator.userAgent);
    const shouldShowWallet = !isIOSOrMacOS || Boolean(app.data['currentRole']);

    if (
      app.current.matches(HomePage) ||
      app.current.matches(IndexPage) ||
      app.current.matches(MallPage) ||
      app.current.matches(MallOrderPage) ||
      app.current.matches(TagsPage) ||
      app.current.matches(TagView)
    ) {
      isWallet = true;
    }
    if (app.current.matches(HomePage) || app.current.matches(IndexPage) || app.current.matches(TagsPage) || app.current.matches(TagView)) {
      isOne = true;
      appNavigation.className = 'App-navigation';
    } else if (
      app.current.matches(UserPage) ||
      app.current.matches(LikePage) ||
      app.current.matches(SettingPage) ||
      app.current.matches(MentionPage) ||
      app.current.matches(ProfilePagePhone) ||
      app.current.matches(DiscussionPage) ||
      app.current.matches(MallPage) ||
      app.current.matches(MallOrderPage)
    ) {
      appNavigation.className = 'App-navigation';
    } else if (
      app.current.matches(SearchView) ||
      app.current.matches(NotificationsPage) ||
      app.current.matches(FlagsPage) ||
      app.current.matches(CommentsPage) ||
      app.current.matches(LikesPage) ||
      app.current.matches(PayPage)
    ) {
      appNavigation.className = 'App-navigation';
      isSearch = false;
    } else {
      isOne = true;
      isTwo = true;
      appNavigation.className = 'App-navigation-new';
    }

    if (app.store.models.type !== 'phone') {
      isCS = true;
      isWallet = true;
      isSearch = true;
      if (app.current.matches(SearchView)) {
        isSearch = false;
      }
    }

    const user = app.session.user!;
    // 将字符串映射转换为 JavaScript 对象
    const obj = JSON.parse(pkgLogo.pkgName);
    // 创建 Map 对象并初始化
    const map = new Map(Object.entries(obj));
    // 获取特定键的值
    let localePkgName = map.get(app.data.locale);
    // 将字符串映射转换为 JavaScript 对象
    const obj2 = JSON.parse(pkgLogo.pkgLogo);
    // 创建 Map 对象并初始化
    const map2 = new Map(Object.entries(obj2));
    // 获取特定键的值
    let localePkgLogo = map2.get(app.data.locale);
    return (
      <div>
        <div className="Navigation-box-lin">
          {isOne ? (
            <div
              className={classList('Navigation ButtonGroup', this.attrs.className)}
              onmouseenter={pane && pane.show.bind(pane)}
              onmouseleave={pane && pane.onmouseleave.bind(pane)}
            >
              {this.getDrawerButton()}
              <LinkButton href={app.route('pages.home')} className="Navigation-title">
                <p>{localePkgName}</p>
                <img className="Navigation-img" src={localePkgLogo}></img>
              </LinkButton>
              {/* <text className="Navigation-title">
                <p>{localePkgName}</p>
              </text> */}

              {/* <Button
                className="Navigation-back-btn"
                aria-label="back"
                onclick={(e: MouseEvent) => {
                  if (e.shiftKey || e.ctrlKey || e.metaKey || e.which === 2) return;
                  e.preventDefault();
                  history?.back();
                }}
              ></Button> */}
            </div>
          ) : (
            <div
              className={classList('Navigation ButtonGroup', this.attrs.className)}
              onmouseenter={pane && pane.show.bind(pane)}
              onmouseleave={pane && pane.onmouseleave.bind(pane)}
            >
              {history?.canGoBack() ? [this.getBackButton(), this.getPaneButton()] : this.getDrawerButton()}
              {/* {app.current.matches(DiscussionPage) && (
                <text className="Navigation-title">
                  <p>{localePkgName}</p>
                </text>
              )} */}
              {isCS && (
                <>
                  <LinkButton href={app.route('pages.home')} className="Navigation-title">
                    <p>{localePkgName}</p>
                    <img className="Navigation-img" src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/logo.png`}></img>
                  </LinkButton>
                </>
              )}
            </div>
          )}
          {
            !isOne && isCS && (<div>{app.current.matches(SearchView) && SearchView.prototype.title()}</div>)
          }
          <div className="Navigation-right-lin">
            {isWallet && walletStatus && shouldShowWallet ? (
              <a
                onclick={(event) => {
                  event.stopPropagation();
                  if (!app.session.user) {
                    event.preventDefault();
                    app.modal.show(LogInModal);
                    return;
                  }
                }}
                href={app.route('pay', { type: 'postPayed' })}
                className="my-wallet-btn"
              >
                <div className="btn">
                  <a>
                    <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-qianbao.png`}></img>
                  </a>
                </div>
                <div className="money">${app.store.balance ? app.store.balance : '0'}</div>
              </a>
            ) : (
              <></>
            )}
            {app.session.user && isWallet && <LinkButton href={app.route.user(app.session.user)}>{avatar(app.session.user)}</LinkButton>}
            {isCS && feedbackStatus && (
              <Button
                className="customer-service"
                aria-label="feedback"
                onclick={() => {
                  if (!app.session.user) {
                    app.modal.show(LogInModal);
                    return;
                  }
                  let entranceId = app.data.pkgLogo.entranceId;
                  // 打开反馈页面
                  AIHelpSupport.show(entranceId ? entranceId : 'E001');
                  // let feedbackUrl = app.forum.attribute('feedbackUrl');
                  // if (app.session.user.isAdmin()) {
                  //   window.open(
                  //     `${feedbackUrl}/feedback/?userId=${app.session.user.uniqueID()}&isAdmin=${app.session.user.isAdmin()}&pkgId=${
                  //       app.data.pkgLogo.id
                  //     }&lang=${app.data.locale}#/AdminFeedbackList`
                  //   );
                  // } else {
                  //   window.open(
                  //     `${feedbackUrl}/feedback/?userId=${app.session.user.uniqueID()}&isAdmin=${app.session.user.isAdmin()}&pkgId=${
                  //       app.data.pkgLogo.id
                  //     }&lang=${app.data.locale}&avatar=${app.session.user.avatarUrl()}#/userFeedback`
                  //   );
                  // }
                }}
              >
                <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/btm-keff.png`}></img>
              </Button>
            )}

              {/* <Button
                className="customer-service"
                aria-label="feedback"
                onclick={() => {
                  if (!app.session.user) {
                    app.modal.show(LogInModal);
                    return;
                  }
                  app.request({
                    method: 'POST',
                    url: app.forum.attribute('apiUrl') + '/chatUserLogin',
                    params: {},
                    // errorHandler: this.onerror.bind(this),
                  }).then((res) => {
                     if (res) {
                      let userToken =  res.token;
                
                     }
                  })
                }}
              >
                Chat
              </Button> */}
            {isSearch && <SearchButton />}
          </div>
        </div>
        {isTwo && (
          <div className="Navigation-next">
            <div
              className={classList('Navigation ButtonGroup', this.attrs.className)}
              onmouseenter={pane && pane.show.bind(pane)}
              onmouseleave={pane && pane.onmouseleave.bind(pane)}
            >
              {history?.canGoBack() ? [this.getBackButton(), this.getPaneButton()] : null}
            </div>
            {/* <PostButton /> */}
          </div>
        )}
      </div>
    );
    // } else {
    //   return (
    //     <>
    //     <div
    //       className={classList('Navigation ButtonGroup', this.attrs.className)}
    //       onmouseenter={pane && pane.show.bind(pane)}
    //       onmouseleave={pane && pane.onmouseleave.bind(pane)}
    //     >
    //       {history?.canGoBack() ? [this.getBackButton(), this.getPaneButton()] : this.getDrawerButton()}
    //     </div>
    //     <div className="Navigation-right-lin">
    //     {<SearchButton />}
    //   </div>
    //   </>
    //   );
    // }
  });

  override(DiscussionComposer.prototype, 'headerItems', function (original) {
    // if (app.store.models.type == 'phone') {
    const items = new ItemList();

    items.add('title', <h3>{app.translator.trans('core.forum.composer_discussion.title')}</h3>, 100);

    items.add(
      'discussionTitle',
      <h3>
        {this.titleSlug() ? <span className="composer-title">{this.titleSlug()}</span> : <></>}
        <input
          className="FormControl"
          maxlength="50"
          bidi={this.title}
          placeholder={this.attrs.titlePlaceholder}
          disabled={!!this.attrs.disabled}
          onkeydown={this.onkeydown.bind(this)}
          required
        />
        <div className="counter">{this.title() ? this.title().length : 0}/50</div>
      </h3>
    );

    return items;
    // } else {
    //   return original();
    // }
  });

  override(TextEditor.prototype, 'view', function (original) {
    // if (app.store.models.type == 'phone') {
    return (
      <div className="TextEditor">
        <div className="TextEditor-editorContainer" id="imageContainer"></div>
        <div className="TextEditor-operation">
          <ul className="TextEditor-controls Composer-footer">
            {listItems(this.controlItems().toArray())}
            <li className="TextEditor-toolbar">{this.toolbarItems().toArray()}</li>
          </ul>
          <Button className="TextEditor-submit-btn" onclick={this.onsubmit.bind(this)}>
            {app.translator.trans('dl-pay.forum.operation.post')}
          </Button>
        </div>
      </div>
    );
    // } else {
    //   return original();
    // }
  });

  extend(DiscussionComposer.prototype, 'footItems', function (items) {
    // if(app.store.models.type == 'phone') {
    items.add('uploadFile', <UploadFileButton uploader={this.uploader} onchange={this.mainImg} />, 100);
    // let tagMap = app.store.all('tags').filter((tag) => !tag.isAllTag() && tag.pkgId() == app.data.pkgLogo.id);
    let pkgActivityMap = [];
    pkgActivityMap.push({ id: 0 });
    app.store.all('pkgActivityCategories').filter((pkgActivity) => {
      if (pkgActivity.isLoading() && pkgActivity.type() == 0) {
        pkgActivityMap.push(pkgActivity);
      }
    });

    items.add(
      'tagLists',
      <div className={'activity ' + (this.activityTag() != 0 ? 'activity-check' : '')}>
        <Dropdown
          buttonClassName="Button"
          // label={sortOptions[app.search.params().sort] || Object.keys(sortMap).map((key) => sortOptions[key])[0]}
          label={this.activityTitle()}
          accessibleToggleLabel={app.translator.trans('core.forum.index_sort.toggle_dropdown_accessible_label')}
        >
          {pkgActivityMap.map((category, key) => {
            // let value = new Map();
            // value.set('0', category.id());
            let tagsObj = [];
            if (key !== 0) {
              let activityTag = category.activityTag();
              if (activityTag.length > 0) {
                activityTag.forEach((element) => {
                  tagsObj.push({ id: element.id(), name: element.name(), tag: element.tagObj(), description: element.description() });
                });
              }
            } else {
              tagsObj.push({ id: 0, name: app.translator.trans('dl-discussionComposer.forum.unSelect'), tag: 0, description: '' });
            }

            return tagsObj.map((category2) => {
              let localDescription = '';
              let name = category2?.name;
              let localeName = category2?.name;
              let description = category2?.description;
              if (name && category2.id != 0) {
                // 将字符串映射转换为 JavaScript 对象
                const obj = JSON.parse(name);
                // 创建 Map 对象并初始化
                const map = new Map(Object.entries(obj));
                // 获取特定键的值
                localeName = map.get(app.data.locale);
                // tagList.set(category2?.id, localeName);
              }
              if (description) {
                const obj2 = JSON.parse(description);
                const map2 = new Map(Object.entries(obj2));
                localDescription = map2.get(app.data.locale);
              }

              return (
                <Button
                  className="activity-btn"
                  onclick={() => {
                    if (category2.id != 0 && !app.data['currentRole']) {
                      app.modal.show(RouteToBindRoleModal, {
                        text: app.translator.trans('dl-response.forum.warn.no_binding_role'),
                        promise: true,
                        onconfirm: (resolve, reject) => {
                          app.modal.show(RoleBindingModal);
                          // let url = app.forum.attribute('baseUrl');
                          // window.open(url + '/u/' + app.session.user.username(), "_blank");
                          // app.route.user(app.session.user);
                        },
                      });
                      return;
                    }
                    this.adtivityId(0);
                    this.activityTag(0);
                    this.activityTitle(app.translator.trans('dl-response.forum.discussion.activity'));
                    this.titleSlug('');
                    this.composer.fields.tags = [];

                    // this.activityTag(jsonString)
                    // if (category2.id == 0) return
                    if (category2.id != 0) {
                      this.adtivityId(category.id());
                      this.activityTag(category2.id);
                      this.activityTitle(localeName);
                      this.titleSlug(`【${localeName}】`);
                      if (category2.tag) {
                        this.composer.fields.tags = [category2.tag];
                      } else {
                        this.composer.fields.tags = [];
                      }
                    }
                  }}
                >
                  <div className="activity-title">{localeName}</div>
                  <div className="activity-content">{localDescription}</div>
                </Button>
              );
            });
          })}
        </Dropdown>
      </div>,
      5
    );

    return items;
    // }
  });
  extend(EditPostComposer.prototype, 'footItems', function (items) {
    if (this.attrs.post.number() !== 1) return;
    items.add('uploadFile', <UploadFileButton uploader={this.uploader} onchange={this.mainImg} />, 100);

    return items;
  });

  override(ComposerState.prototype, 'maximumHeight', function (original) {
    // if (app.store.models.type == 'phone') {
    return $(window).height();
    // } else {
    //   return original();
    // }
  });

  override(Composer.prototype, 'updateHeight', function (original) {
    // if (app.store.models.type == 'phone') {
    const height = this.state.computedHeight();
    const $flexible = this.$('.Composer-flexible');

    this.$().height(height);

    if ($flexible.length) {
      const headerHeight = $flexible.offset().top - this.$().offset().top;
      const paddingBottom = parseInt($flexible.css('padding-bottom'), 10);
      const footerHeight = this.$('.Composer-footer').outerHeight(true);
      const imgHeight = this.$('.TextEditor-imgContainer').outerHeight(true);

      $flexible.height(this.$().outerHeight() - headerHeight - paddingBottom - footerHeight - imgHeight);
    }
    // } else {
    //   return original();
    // }
  });

  override(DiscussionPage.prototype, 'view', function (original) {
    // if (app.store.models.type == 'phone') {
    return (
      <div className="DiscussionPage dl-content">
        <DiscussionListPane state={app.discussions} />
        <div className="DiscussionPage-discussion">{this.discussion ? this.pageContent().toArray() : this.loadingItems().toArray()}</div>
        {/* {Object.keys(app.alerts.activeAlerts).length > 0 ? (
          <div className="loading-box">
            <div className="loading-text">{app.translator.trans('dl-response.forum.warn.discussion_is_empty')}</div>
            <LinkButton className="back-home-btn" href={app.route('pages.home')}>
              {app.translator.trans('dl-response.forum.button.return_homePage')}
            </LinkButton>
          </div>
        ) : null} */}
        {this.discussion?.detailPageImgOne() && (
          <div className="sideFloating left">
            <img src={this.discussion.detailPageImgOne()}></img>
          </div>
        )}
        {this.discussion?.detailPageImgTwo() && (
          <div className="sideFloating right">
            <img src={this.discussion.detailPageImgTwo()}></img>
          </div>
        )}
      </div>
    );
    // } else {
    //   return original();
    // }
  });

  override(DiscussionPage.prototype, 'sidebar', function (original) {
    // if (app.store.models.type == 'phone') {
    return (
      <nav className="DiscussionPage-nav dl-segmentation ">
        <ul>{listItems(this.sidebarItems().toArray())}</ul>
      </nav>
    );
    // } else {
    //   return original();
    // }
  });

  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    // if (app.store.models.type == 'phone') {
    items.remove('controls');
    items.remove('scrubber');
    return items;
    // }
  });

  extend(DiscussionPage.prototype, 'oninit', function (items) {
    if (app.store.models.type == 'phone') {
      // app.history.push(`d/${this.attrs.routeName}`);
    }
  });

  extend(DiscussionPage.prototype, 'pageContent', function (items) {
    // if (app.store.models.type == 'phone') {
    items.remove('hero');
    items.setContent('main', <div className="container dl-discussionPage container-lin">{this.mainContent().toArray()}</div>, 10);
    return items;
    // }
  });

  override(PostStream.prototype, 'view', function (original) {
    // if (app.store.models.type == 'phone') {
    let lastTime;

    const viewingEnd = this.stream.viewingEnd();
    const discussion = this.stream.discussion;
    const firstPost = app.store.getById('posts', discussion.firstPost().id());
    const posts = this.stream.posts();
    const postIds = this.discussion.postIds();

    // app.session.user.id() == posts.user().id;
    const postFadeIn = (vnode) => {
      $(vnode.dom).addClass('fadeIn');
      // 500 is the duration of the fadeIn CSS animation + 100ms,
      // so the animation has time to complete
      setTimeout(() => $(vnode.dom).removeClass('fadeIn'), 500);
    };
    if (!posts.find((item) => item === firstPost)) {
      posts.push(firstPost);
    }

    const items = posts
      .sort((a, b) => {
        if (a && a.number() === 1) return -1; // 将 post.number() 为 1 的放在第一个位置
        if (b && b.number() === 1) return 1; // 将 post.number() 为 1 的放在第一个位置
        if (!a || !b) return;
        // return b.createdAt() - a.createdAt();
      })
      .map((post, i) => {
        let content;
        const attrs = { 'data-index': this.stream.visibleStart + i };
        let hideReply = false;
        if (post) {
          const isTopLevel = post.number() === 1 || post.replyTo() == 0;
          const time = post.createdAt();
          const PostComponent = app.postComponents[post.contentType()];

          attrs.key = 'post' + post.id();
          attrs['data-number'] = post.number();
          attrs['data-id'] = post.id();
          attrs['data-type'] = post.contentType();
          const user = post.user();
          if (user) {
            attrs['data-userid'] = user.id();
          }

          if (isTopLevel) {
            content = !!PostComponent && <PostComponent post={post} discussion={this.discussion} />;
            attrs.oncreate = postFadeIn;
            attrs['data-time'] = time.toISOString();

            // If the post before this one was more than 4 days ago, we will
            // display a 'time gap' indicating how long it has been in between
            // the posts.
            const dt = time - lastTime;

            // if (dt > 1000 * 60 * 60 * 24 * 4) {
            //   content = [
            //     <div className="PostStream-timeGap">
            //       <span>{app.translator.trans('core.forum.post_stream.time_lapsed_text', { period: dayjs().add(dt, 'ms').fromNow(true) })}</span>
            //     </div>,
            //     content,
            //   ];
            // }

            lastTime = time;
          } else {
            hideReply = true;
            content = null;
          }
        } else {
          attrs.key = 'post' + postIds[this.stream.visibleStart + i];

          content = <PostLoading />;
        }
        return (
          <div
            className={classList('PostStream-item', hideReply && 'PostStream-item--hidden')}
            style={hideReply ? { display: 'none' } : undefined}
            {...attrs}
          >
            {content}
          </div>
        );
      });

    let loadMoreBtn = [];

    if (!viewingEnd && posts[this.stream.visibleEnd - this.stream.visibleStart - 1]) {
      loadMoreBtn.push(
        <div className="PostStream-loadMore" key="loadMore">
          <Button className="Button" onclick={this.stream.loadNext.bind(this.stream)}>
            {app.translator.trans('core.forum.post_stream.load_more_button')}
          </Button>
        </div>
      );
    }

    // Allow extensions to add items to the end of the post stream.
    if (viewingEnd) {
      items.push(...this.endItems().toArray());
    }

    // If we're viewing the end of the discussion, the user can reply, and
    // is not already doing so, then show a 'write a reply' placeholder.
    // if (viewingEnd && (!app.session.user || this.discussion.canReply())) {
    //   items.push(
    //     <div className="PostStream-item" key="reply" data-index={this.stream.count()} oncreate={postFadeIn}>
    //       <ReplyPlaceholder discussion={this.discussion} />
    //     </div>
    //   );
    // }
    // 切换排序时：首帖(firstPost)继续展示，对后面的评论区显示 loading
    if (this.attrs.isSorting) {
      return (
        <div className="PostStream" role="feed" aria-live="off" aria-busy="true">
          {items.slice(0, 1)}
          <div className="PostStream-sort">
            <div className="dl-segmentation"></div>
            <ResponseItemsBtn
              sort={this.attrs.sort}
              onChangeSort={this.attrs.onChangeSort}
              onDataFromChild={(data) => {
                this.switchBtn = data;
              }}
            />
          </div>
          <div className="PostStream-loading">
            <LoadingIndicator />
          </div>
        </div>
      );
    }

    return (
      <div className="PostStream" role="feed" aria-live="off" aria-busy={this.stream.pagesLoading ? 'true' : 'false'}>
        {items.slice(0, 1)}
        <div className="PostStream-sort">
          <div className="dl-segmentation"></div>
          <ResponseItemsBtn
            sort={this.attrs.sort}
            onChangeSort={this.attrs.onChangeSort}
            onDataFromChild={(data) => {
              this.switchBtn = data;
            }}
          />
        </div>
        {items.slice(1)}
        {loadMoreBtn.length > 0 ? loadMoreBtn : ''}
      </div>
    );
    // } else {
    //   return original();
    // }
  });

  extend(CommentPost.prototype, 'headerItems', function (items) {
    // if (app.store.models.type == 'phone') {
    items.setContent(
      'user',
      <PostUser
        post={this.post}
        discussion={this.discussion}
        cardVisible={this.cardVisible}
        oncardshow={() => {
          this.cardVisible = true;
          m.redraw();
        }}
        oncardhide={() => {
          this.cardVisible = false;
          m.redraw();
        }}
      />,
      100
    );

    items.remove('meta');

    return items;
    // }
  });

  extend(CommentPost.prototype, 'footerItems', function (items) {
    // if (app.store.models.type == 'phone') {
    items.remove('replies');
    items.remove('liked');

    return items;
    // }
  });

  override(PostUser.prototype, 'view', function (original) {
    // if (app.store.models.type == 'phone') {
    const post = this.attrs.post;
    const discussion = this.attrs.discussion;
    let user = post.user();
    let userId = user.id();
    let userLevel = user?.userLevel();
    let levelImg = undefined;
    let levelColor;
    let levelImgs;
    let levelImgRes;
    let levelColors;
    let levelColorRes;
    if (userLevel) {
      levelImgs =  userLevel?.levelConf()?.levelImg();
      if (levelImgs) {
        levelImgRes  = JSON.parse(levelImgs);
        levelImg = levelImgRes[app.data.pkgLogo.id];
      }
      levelColors =  userLevel.levelConf().color();
      if (levelColors) {
        levelColorRes  = JSON.parse(levelColors);
        levelColor = levelColorRes[app.data.pkgLogo.id];
      }
    } else {
      try {
        levelImgs =  user.data.attributes.levelConf.level_img;
        if (levelImgs) {
          levelImgRes  = JSON.parse(levelImgs);
          levelImg = levelImgRes[app.data.pkgLogo.id];
        }
        levelColors =  user.data.attributes.levelConf.color;
        if (levelColors) {
          levelColorRes  = JSON.parse(levelColors);
          levelColor = levelColorRes[app.data.pkgLogo.id];
        }

      } catch (e) {
        console.log(e);
      }
    }

    if (!user) {
      return (
        <div className="PostUser">
          <h3 className="PostUser-name">
            {avatar(user, { className: 'PostUser-avatar' })} {username(user)}
          </h3>
        </div>
      );
    }

    // 收藏
    let subscription = discussion?.subscription();
    let buttonClass = 'SubscriptionMenu-button--' + subscription;
    buttonClass = 'SubscriptionMenu-button--null';
    let buttonIcon = 'fas fa-star';
    return (
      <div className="PostUser">
        <h3 className="PostUser-name ">
          <div className="DiscussionListItem-texts">
            <Link
              href={app.route.user(user)}
              onclick={(event) => {
                if (!app.session.user) {
                  event.preventDefault();
                  app.modal.show(LogInModal);
                  return;
                }
              }}
            >
              {avatar(user, { className: 'PostUser-avatar' })}
            </Link>
            <div className="DiscussionListItem-box-lin">
              <div className="DiscussionListItem-text DiscussionListItem-text-lin">
                <a
                  href={app.route.user(user)}
                  className="DiscussionListItem-username"
                  onclick={(event) => {
                    if (!app.session.user) {
                      event.preventDefault();
                      app.modal.show(LogInModal);
                      return;
                    }
                  }}
                >
                  {nickname(user)}
                </a>
                <ul className="PostUser-badges badges">{listItems(user.badges().toArray())}</ul>

                <div className="DiscussionListItem-img-box">
                  <img className="DiscussionListItem-img" src={levelImg} />
                  <span
                    className="DiscussionListItem-img-lv"
                    style={`text-shadow: -1px -1px 0 ${levelColor}, 1px -1px 0 ${levelColor}, -1px 1px 0 ${levelColor}, 1px 1px 0 ${levelColor};`}
                  >
                    {user?.userLevel()?.levelConf()?.level()}
                  </span>
                </div>
                {post.number() == 1 && (
                  <div className="DiscussionListItem-tag">
                    <Button
                      className={'collection-btn ' + (subscription ? 'collection-btn-follow-bg' : 'collection-btn-null-bg')}
                      aria-label="collection"
                      onclick={(e) => {
                        if (!app.session.user) {
                          app.modal.show(LogInModal);
                          return;
                        }
                        subscription = ['follow', 'ignore'].indexOf(subscription) == -1 ? 'follow' : null;
                        discussion.save({ subscription });
                        document.getElementsByClassName('collection-btn')[0].className =
                          'collection-btn ' + (subscription ? 'collection-btn-follow-bg' : 'collection-btn-null-bg');
                        // TODO
                      }}
                    ></Button>
                  </div>
                )}
              </div>
              <div className="DiscussionListItem-state">
                <p className="DiscussionListItem-time">{humanTime(post.createdAt())}</p>
                {discussion?.badges() && <ul className="DiscussionListItem-badges badges">{listItems(discussion.badges().toArray())}</ul>}
              </div>
            </div>
          </div>
          {/* {userOnline(user)} */}
        </h3>

        {/* {!post.isHidden() && this.attrs.cardVisible && (
          <UserCard user={user} className="UserCard--popover" controlsButtonClassName="Button Button--icon Button--flat" />
        )} */}
      </div>
    );
    // } else {
    //   return original();
    // }
  });
}
